import { render, staticRenderFns } from "./ReportScorings.vue?vue&type=template&id=0525d870&"
import script from "./ReportScorings.vue?vue&type=script&lang=js&"
export * from "./ReportScorings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports